/**
 * @Author: Zewei
 * @Date:   2018-02-11T10:48:06+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-24T11:11:20+08:00
 */

import _util from '../../utils/';

const otherReportService = {
    fetchReportsList(params, resolve, reject) {
        _util.request({
            url: '/api/HRWorkReport/Get',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchWorkReportInit(params, resolve, reject) {
        _util.request({
            url: '/api/HRWorkReport/Post',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchCurrentUserDetail(params, resolve, reject) {
        _util.request({
            url: '/api/auth/userinfo',
            params: params,
            success: resolve,
            error: reject
        })
    },
    createWorkReport(data, resolve, reject) {
        _util.request({
            url: '/api/HRWorkReport/SubmitReport',
            method: 'PUT',
            data: data,
            success: resolve,
            error: reject
        })
    },
    fetchReportDetail(id, resolve, reject) {
        _util.request({
            url: `/api/HRWorkReport/Details?modelId=${id}`,
            success: resolve,
            error: reject
        })
    },
    multiDeleteReports(data, resolve, reject) {
        _util.request({
            url: '/api/HRWorkReport/Delete',
            method: 'DELETE',
            data: data,
            success: resolve,
            error: reject
        })
    },
}



export default otherReportService;



// WEBPACK FOOTER //
// ./src/services/DailyReport/other-report-service.js